import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { get } from 'lodash';

import {
  COMMUNITIES_ACCESS_LEVELS,
  COMMUNITIES_USER_ROLES,
} from '../../../constants';
import { COMMUNUNNITY_NEW_POST } from '../../../constants/strings';
import { useToggleFlag } from '../../../hocs/useToogleFlag';
import getButtonInfo from '../../../utils/communities/getButtonInfo';
import { CommunityMenu } from '../CommunityMenu';
import Button from '../../Button';
import PostForm from './PostForm';
import { enhance } from './enhance';
import { InviteBtn } from './InviteBtns';

const {
  READ_AND_POST,
  READ_AND_POST_WITH_APPROVAL,
} = COMMUNITIES_ACCESS_LEVELS;

const NewPostButton = ({
  intl: { formatMessage },
  createPost,
  reqJoinCommunity,
  openJoinPopup,
  isLoggedIn,
  accessLevel,
  createPostRequest: { sending, rejected, error, succeed },
  community,
  isModerator,
}) => {
  const [isModalOpen, openModal, closeModal] = useToggleFlag();
  const [
    isNotificationOpen,
    openNotification,
    closeNotification,
  ] = useToggleFlag();

  const [postError, setPostError] = useState('');
  const {
    id: communityId,
    name,
    currentUserRole,
    memberInvitationId,
  } = community;

  useEffect(() => {
    if (succeed) {
      closeModal();
    }
  }, [succeed]);

  useEffect(() => {
    if (rejected) {
      setPostError(get(error, 'description'));
    }
  }, [rejected]);

  const { buttonText, disabled, id: btnID } = getButtonInfo(
    community,
    formatMessage,
    true,
  );

  const handleClosePopup = () => {
    setPostError('');
    closeModal();
  };

  const onSubmitPost = data => {
    if (!communityId) {
      throw new Error('NewPost: required communityId prop is missing');
    }
    if (!data || !(data instanceof FormData)) {
      throw new Error('NewPost: wrong data passed');
    }

    data.append('communityId', communityId);

    createPost(data);
  };

  const checkButtonAction = () => {
    if (isLoggedIn) {
      return currentUserRole ? openModal() : reqJoinCommunity({ communityId });
    }
    openJoinPopup({ content: 'join' });
  };

  const canPost =
    currentUserRole === COMMUNITIES_USER_ROLES.MODERATOR ||
    accessLevel === READ_AND_POST ||
    accessLevel === READ_AND_POST_WITH_APPROVAL;
  const showButton = !currentUserRole || (currentUserRole && canPost);
  const buttonCondition = showButton && !memberInvitationId;

  return (
    <div styleName={cn('wrapper__action', { 'full-width': buttonCondition })}>
      <If condition={buttonCondition}>
        <Button
          id={btnID}
          color="primary"
          raised
          type="button"
          onClick={checkButtonAction}
          className="w-100"
          disabled={disabled}
        >
          {buttonText}
        </Button>
      </If>

      <If condition={memberInvitationId}>
        <InviteBtn invitationId={memberInvitationId} />
      </If>

      <If condition={isLoggedIn}>
        <CommunityMenu community={community} />
      </If>
      <PostForm
        modalTitle={formatMessage(COMMUNUNNITY_NEW_POST.title, { name })}
        discardModalTitle={formatMessage({
          id: 'community.newPost.cancelPost',
        })}
        isModalOpen={isModalOpen}
        submitting={sending}
        onSubmit={onSubmitPost}
        onCancel={handleClosePopup}
        error={postError}
        key={isModalOpen}
        discardBtnText={formatMessage({ id: 'post.actions.discardPost' })}
        accessLevel={accessLevel}
        isModerator={isModerator}
        isNotificationOpen={isNotificationOpen}
        openNotification={openNotification}
        closeNotification={closeNotification}
      />
    </div>
  );
};

NewPostButton.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  community: PropTypes.object.isRequired,
  createPost: PropTypes.func,
  createPostRequest: PropTypes.shape({
    sending: PropTypes.bool,
    rejected: PropTypes.bool,
    succeed: PropTypes.bool,
    error: PropTypes.object,
  }),
  accessLevel: PropTypes.string,
  reqJoinCommunity: PropTypes.func,
  isLoggedIn: PropTypes.bool,
  openJoinPopup: PropTypes.func,
  isModerator: PropTypes.bool,
};

export default enhance(NewPostButton);



// WEBPACK FOOTER //
// ./src/components/Community/NewPost/index.jsx